import Vue from 'vue';
import Vuex from 'vuex';
import Alert from './modules/alert';
import Auth from './modules/auth';
import Posts from './modules/posts';
import Teams from './modules/teams';
import Subjects from './modules/subjects';
import Lessons from './modules/lessons';
import Homework from './modules/homework';
import Users from './modules/users';
import Quizzes from './modules/quizzes';
import Results from './modules/results';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Alert,
    Auth,
    Posts,
    Teams,
    Subjects,
    Lessons,
    Homework,
    Users,
    Quizzes,
    Results
  }
})
